/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'confluence.error.panel.refresh.app': 'App vernieuwen',
  'confluence.error.panel.reload.page': 'Pagina opnieuw laden',
  'confluence.icon.label': 'Pictogram',
  'confluence.modal.dialog.close.modal.button': 'Annuleren',
  'confluence.select.required.field.message': 'Dit veld is vereist.',
  'confluence.text.area.required.field.message': 'Dit veld is vereist.',
  'confluence.textfield.validator.email': 'Voer een geldig e-mailadres in.',
  'confluence.textfield.validator.number': 'Voer een geldig cijfer in',
  'confluence.textfield.validator.required.field.message': 'Dit veld is vereist.',
  'confluence.textfield.validator.telephone': 'Voer een geldig telefoonnummer in.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Toegang vereist',
  'confluence.threeLOPrompt.modal.error.title': 'Fout',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Toestemmings-URL niet gevonden. Vernieuw de pagina en probeer het opnieuw.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Toestemmings-URL niet gevonden. Vernieuw de pagina en probeer het opnieuw.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Toegang toestaan',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Toegang configureren',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Authenticatie mislukt.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Om {appString} te kunnen weergeven, moet je de app toestemming geven om namens jou toegang te krijgen tot Atlassian-producten.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} vereist aanvullende toegang tot je account.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Waarschuwing voor externe authenticatie',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'deze app',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Deze app',
  'confluence.user.group.unknown.user.message': 'Onbekende gebruiker',
  'confluence.user.picker.empty.field.error.message': 'Dit veld is vereist.',
  'confluence.user.unknown.user.message': 'Onbekende gebruiker',
  'forge-ui.form.submit-button.text': 'Verzenden',
};
